import React from 'react';
import { cn } from '@/lib/utils';
interface AppCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'compact' | 'normal' | 'large';
  variant?: 'default' | 'glass' | 'subtle';
  onClick?: () => void;
}
export function AppCard({
  children,
  className = '',
  hover = false,
  padding = 'normal',
  variant = 'default',
  onClick
}: AppCardProps) {
  const paddingClasses: Record<string, string> = {
    none: '',
    compact: 'p-4',
    normal: 'p-6',
    large: 'p-8'
  };
  const variantClasses: Record<string, string> = {
    default: 'bg-[#1a1a1a] border border-white/[0.08] rounded-2xl',
    glass: 'bg-[#1a1a1a] border border-white/[0.08] rounded-2xl shadow-lg',
    subtle: 'bg-transparent border border-white/[0.08] rounded-2xl'
  };
  return <div className={cn(variantClasses[variant] || variantClasses.default, paddingClasses[padding] || '', onClick && 'cursor-pointer transition-all duration-200 hover:border-[#8eff01]/20 hover:shadow-[0_0_24px_rgba(142,255,1,0.04)]', className)} onClick={onClick} data-id="element-44">
      {children}
    </div>;
}